import headerThemeSetups from 'components/activity-display/control-header/headerThemeSetups';
import { HeaderThemeOption } from 'interfaces/HeaderThemeSetups';

function getHeaderElementSetup(cmsSlug: string | null, cmsThemeSlug: string | null, cmsThemeVersion: string | null) {
	if (cmsSlug && cmsThemeSlug && headerThemeSetups[cmsSlug] && headerThemeSetups[cmsSlug][cmsThemeSlug]) {
		if (cmsThemeVersion && headerThemeSetups[cmsSlug][cmsThemeSlug][cmsThemeVersion])
			return headerThemeSetups[cmsSlug][cmsThemeSlug][cmsThemeVersion];
		else
			return headerThemeSetups[cmsSlug][cmsThemeSlug].default;
	} else {
		const defaultOptions:HeaderThemeOption[] = [
			{ name: 'masthead', type: 'id', isSticky: false } // Example: WordPress default header ID
		];
	
		return defaultOptions;
	}
}

export default getHeaderElementSetup;